import React, { useEffect, useState } from 'react';
import { Text } from 'react-native';
import formatDistance from 'date-fns/formatDistance';

const TimeAgo = ({
  dateTo,
  dateFrom,
  updateInterval = 60000,
  hideAgo = false,
  style
}) => {
  const [currentDate, setCurrentDate] = useState(new Date());
  useEffect(() => {
    const interval = setInterval(() => {
      if (!dateFrom) setCurrentDate(new Date());
    }, updateInterval);
    return () => clearInterval(interval);
  }, [dateFrom, updateInterval]);
  return /*#__PURE__*/React.createElement(Text, {
    style
  }, formatDistance(dateTo, dateFrom || currentDate, {
    addSuffix: !hideAgo
  }));
};

export default TimeAgo;
//# sourceMappingURL=index.js.map